var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.9226 0H5.84048C3.08744 0 0.850586 2.26563 0.850586 5.04688V64.9531C0.850586 67.7344 3.08744 70 5.84048 70H65.9226C68.6756 70 70.9281 67.7344 70.9281 64.9531V5.04688C70.9281 2.26563 68.6756 0 65.9226 0ZM22.0303 60H11.6438V26.5938H22.0459V60H22.0303ZM16.837 22.0312C13.5052 22.0312 10.8147 19.3281 10.8147 16.0156C10.8147 12.7031 13.5052 10 16.837 10C20.1532 10 22.8593 12.7031 22.8593 16.0156C22.8593 19.3438 20.1688 22.0312 16.837 22.0312ZM60.964 60H50.5775V43.75C50.5775 39.875 50.4993 34.8906 45.1809 34.8906C39.7686 34.8906 38.9396 39.1094 38.9396 43.4688V60H28.5531V26.5938H38.5173V31.1562H38.658C40.0502 28.5312 43.4446 25.7656 48.497 25.7656C59.0087 25.7656 60.964 32.6875 60.964 41.6875V60Z",
    fill: "#233B92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.8ad89c8340c8fae9929336c09216702f.svg";
export { ForwardRef as ReactComponent };